module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('el-divider', [_vm._v("食宿人数" + _vm._s(_vm.sai_member_count) + "人")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "领队",
      "value": "1"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "运动员",
      "value": _vm.row.yundongyuan_count
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "教练员",
      "value": _vm.row.jiaolian_count
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "裁判员",
      "value": _vm.row.caipan_count
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "随行人员",
      "placeholder": "请选择人员"
    },
    on: {
      "click": function($event) {
        _vm.showFamliyPicker = true
      }
    }
  }), _vm._v(" "), _c('FamliyPicker', {
    attrs: {
      "show": _vm.showFamliyPicker,
      "limit": 100,
      "defaultValue": _vm.formData.famliy
    },
    on: {
      "onChange": _vm.onFamliyChange,
      "onClose": function($event) {
        _vm.showFamliyPicker = false
      },
      "onConfirm": _vm.onFamliyConfirm
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.famliy.length > 0),
      expression: "formData.famliy.length>0"
    }],
    staticClass: "memberResultWrap"
  }, [_vm._l((_vm.formData.famliy), function(famliy, index) {
    return _c('div', {
      staticClass: "memberLi"
    }, [_vm._v("\n                    随行人员" + _vm._s(index + 1) + "\n                    "), _c('van-tag', {
      key: index,
      attrs: {
        "round": "",
        "color": "#fff",
        "text-color": "#666",
        "size": "large",
        "closeable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.famliy.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(famliy.name) + " " + _vm._s(famliy.num) + "\n                    ")])], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "28px",
      "padding-top": "10px",
      "font-size": "14px",
      "text-align": "center",
      "color": "#666"
    }
  }, [_vm._v("\n                    跟大会安排并缴费食宿费和餐车费的随行家长需添加身份证信息，若全程不跟大会，请勿添加。"), _c('br')])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cf6997a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiApplyFormStep3.vue
// module id = 1561
// module chunks = 0